import { CheckOutlined } from '@ant-design/icons';
import { Avatar, Badge, Card, Col, Empty, Modal, Row, Space, Typography } from 'antd';
import React, { useContext } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { Staff } from '@/models/staff';
import { POSBaseInfoContext } from '../LayoutPOS/Synchronizer';

const StaffCard = ({ staff, onClick }: { staff: Staff; onClick: (staff: Staff) => void }) => {
  const [{ assetsPrefix }] = useContext(BaseInfoContext);
  return (
    <Card
      style={{ textAlign: 'center' }}
      onClick={() => {
        onClick?.(staff);
      }}>
      <Space direction="vertical" size={20} align="center">
        <Avatar src={`${assetsPrefix}${staff.avatar}`} size={50} />
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          {staff.nickname}
        </Typography.Title>
      </Space>
    </Card>
  );
};
const StaffList = ({
  staffList,
  selected = [],
  onSelect,
}: {
  staffList?: Staff[];
  selected?: Staff | Staff[];
  onSelect?: (staff: Staff) => void;
}) => {
  if (!staffList || !staffList.length) {
    return <Empty />;
  }
  const selectedList = Array.isArray(selected) ? selected : selected ? [selected] : [];

  return (
    <Row gutter={[16, 16]}>
      {staffList.map(staff => {
        // const selected = selectedList.
        const isSelected = selectedList.find(v => v.username === staff.username);
        const content = (
          <StaffCard
            staff={staff}
            onClick={staff => {
              onSelect(staff);
            }}
          />
        );
        return (
          <Col span={8} key={staff.username}>
            {isSelected ? (
              <Badge.Ribbon
                text={
                  <>
                    <CheckOutlined /> 已选择
                  </>
                }
                color="green">
                {content}
              </Badge.Ribbon>
            ) : (
              content
            )}
          </Col>
        );
      })}
    </Row>
  );
};

export type SelectOperatorModalProps = {
  operatorList?: Staff[];
  visible: boolean;
  value?: Staff | Staff[];
  onChange?: (value: Staff | Staff) => void;
  zIndex?: number;
  onClose?: () => void;
  onCancel?: () => void;
};

export const SelectOperatorModal = ({
  operatorList,
  value,
  onChange,
  visible,
  onClose,
  onCancel,
  zIndex,
}: SelectOperatorModalProps) => {
  const { getOperatorList } = useContext(POSBaseInfoContext);
  const staffList = operatorList || getOperatorList();
  return (
    <Modal
      zIndex={zIndex}
      open={visible}
      title="请选择美容师"
      footer={null}
      onCancel={() => {
        onCancel();
        onClose();
      }}>
      <StaffList
        staffList={staffList}
        selected={value}
        onSelect={v => {
          onChange?.(v);
          onClose();
        }}
      />
    </Modal>
  );
};

// export const OperatorSelectorForPreOrder = ({
//   preOrder,
//   onComplete,
// }: {
//   preOrder: PreOrder;
//   onComplete: () => void;
// }) => {
//   const { getOperatorList } = useContext(POSBaseInfoContext);
//   const operatorList = getOperatorList();
//   return (
//     <Modal open={visible} title="请选择美容师" footer={null} onCancel={onCancel}>
//       <StaffList
//         staffList={operatorList}
//         selected={value}
//         onSelect={v => {
//           onChange(v);
//         }}
//       />
//     </Modal>
//   );
// };
